import React from "react";
import PointOfSaleCore from "../../components/PointOfSale/Core/index";
import SupermarketEstimate from "./SupermarketEstimate";
import useAuthStore from "../../stores/useAuthStore";

const Estimate = () => {
  const tillData = useAuthStore((s) => s.tillData);
  const tillaccess = JSON.parse(tillData?.tillAccess?.userAccessController || "{}");
  const tillLayout = parseInt(tillaccess?.layout === null || undefined ? 1 : tillaccess?.layout);
  return tillaccess.pos === "Y" ? <PointOfSaleCore component={SupermarketEstimate} /> : <h1>Access Denied</h1>;
};

export default Estimate;
